export default __webpack_public_path__ + "static/media/president_2025.27f8c1b4.jpg";